export {default as Example} from './modules/Example';
export {default as Load} from './modules/Load';
export {default as Footer} from './modules/Footer';
export {default as Header} from './modules/Header';
export {default as Headerfloat} from './modules/HeaderFloat';
export {default as Faqgroup} from './modules/FaqGroup';
export {default as Carousel} from './modules/Carousel';
export {default as Sidemenu} from './modules/Sidemenu';
export {default as Sidemenumobile} from './modules/SidemenuMobile';
export {default as Login} from './modules/Login';
export {default as Pagebanner} from './modules/PageBanner';
export {default as Wishlist} from './modules/Wishlist';
export {default as Slideout} from './modules/Slideout';
export {default as Prompt} from './modules/Prompt';
export {default as Input} from './modules/Input';
export {default as Productcard} from './modules/ProductCard';
export {default as Mainproduct} from './modules/MainProduct';
export {default as Search} from './modules/Search';
export {default as Scrollmodule} from './modules/Scroll';
export {default as Related} from './modules/Related';
export {default as Homehero} from './modules/HomeHero';

